import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceArrayField,
  ChipField,
  SingleFieldList,
  FunctionField,
} from 'react-admin';
import { fromUTC } from '../../lib/i18n/utils';

export function VideoList(props: any) {
  return (
    <List queryOptions={{ meta: { embed: 'lto' } }} exporter={false} sort={{ field: 'name', order: 'ASC' }}>
      <Datagrid rowClick="edit" bulkActionButtons={null}>
        <TextField source="title" sortBy='title' />
        {/* @ts-ignore */}
        <ReferenceArrayField reference="ltos" source="ltoIds">
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
        <FunctionField
          source="publishedAt"
          render={record => fromUTC(record.publishedAt).toLocaleString("nl-NL")}
        />
        <DateField source="createdAt" locales="nl-NL" />
        <TextField source="createdBy.name" sortBy='createdBy' />
      </Datagrid>
    </List>
  );
}
